"use client";

import { PDFDocument } from "pdf-lib";

const imageTypes = new Set(["image/jpeg", "image/png", "image/webp"]);

async function compressImage(file: File) {
  if (file.size < 450_000) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, 2000 / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    const context = canvas.getContext("2d");
    if (!context) return file;
    context.fillStyle = "#fff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", .78));
    if (!blob || blob.size >= file.size) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg", lastModified: file.lastModified });
  } catch {
    return file;
  }
}

async function compressPdf(file: File) {
  if (file.size < 500_000) return file;
  try {
    const document = await PDFDocument.load(await file.arrayBuffer(), { ignoreEncryption: true });
    const bytes = await document.save({ useObjectStreams: true, addDefaultPage: false, updateFieldAppearances: false });
    if (bytes.byteLength >= file.size) return file;
    return new File([bytes], file.name, { type: "application/pdf", lastModified: file.lastModified });
  } catch {
    return file;
  }
}

export async function compressFileForUpload(file: File) {
  if (imageTypes.has(file.type)) return compressImage(file);
  if (file.type === "application/pdf" || file.name.toLocaleLowerCase("fr").endsWith(".pdf")) return compressPdf(file);
  return file;
}
